import { renderEchartToSvg } from "./render-svg";

const renderLineChartSvg = (
  option: any,
  width: number = 820,
  height: number = 420
): Promise<string> => {
  return renderEchartToSvg({
    option,
    width,
    height
  });
};

export default renderLineChartSvg;
